import { AlertTriangle, X } from 'lucide-react';
import { useState } from 'react';
import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const FullReplacementWarning = () => {
	const [dismissed, setDismissed] = useState(false);
	const language = useLanguage();
	const translation = DICTIONARY[language];

	if (dismissed) {
		return null;
	}

	return (
		<div className="bg-warning-300/20 border border-warning-300 rounded-md px-4 py-3 mt-4 flex items-start gap-3">
			<AlertTriangle className="size-5 text-warning-800 flex-shrink-0 mt-0.5" />
			<div className="flex-1">
				<h3 className="text-warning-800 font-bold text-base">{translation.title}</h3>
				<p className="text-warning-800 text-sm">{translation.description}</p>
			</div>
			<button
				type="button"
				onClick={() => setDismissed(true)}
				className="text-warning-800 hover:bg-warning-300/30 rounded p-1"
				aria-label="Dismiss warning"
			>
				<X className="size-5" />
			</button>
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Full replacement mode',
		description:
			'All existing codelist records will be replaced. Records not in the import file will be permanently removed.'
	},
	[LanguageType.Norwegian]: {
		title: 'Full erstatning modus',
		description:
			'Alle eksisterende kodeliste-oppføringer vil bli erstattet. Oppføringer som ikke finnes i importfilen vil bli permanent fjernet.'
	}
} as const;
